import Vue from 'vue';
import { formatTelMaskUK } from '@/utils/formatTelMask';

export default Vue.filter('phoneUK', formatTelMaskUK);


// WEBPACK FOOTER //
// ./src/filters/phoneUK.js